const seoConfig = {

  'localhost:3000': {
    title: 'Infobibliotecas',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/info.ico'
  },

  'infobibliotecas.com': {
    title: 'Infobibliotecas',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/info.ico'
  },

  'www.infobibliotecas.com': {
    title: 'Infobibliotecas',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/info.ico'
  },

  'ochoymedio.es': {
    title: '8 1/2 - Ocho y Medio Libros de Cine',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/8y1_2.ico'
  },

  'www.ochoymedio.es': {
    title: '8 1/2 - Ocho y Medio Libros de Cine',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/8y1_2.ico'
  },

  'cientovolando.click': {
    title: 'Ciento Volando',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/cientovolando.ico'
  },

  'www.cientovolando.click': {
    title: 'Ciento Volando',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/cientovolando.ico'
  },

  'bibliotecas.libelista.com': {
    title: 'Bibliotecas Libelista',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/libelista.ico'
  },

  'www.bibliotecas.libelista.com': {
    title: 'Bibliotecas Libelista',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/libelista.ico'
  },

  'book.theshelfmedia.com': {
    title: 'The Shelf Media',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/shelf.ico'
  },

  'www.book.theshelfmedia.com': {
    title: 'The Shelf Media',
    description: 'Venta de Libros, Ebooks y Más',
    logo: '/logos/shelf.ico'
  },
};

export default seoConfig;
